import { ProductFamily } from '../../../templates/StructuredDataContext';
import { usePageDataset } from '../../../templates/PageDatasetsContext';

interface ProductFamilyQuery {
    allKontentItemDataProductFamily: {
        edges: {
            node: ProductFamily;
        }[];
    };
}

export const useProductFamilies = (): ProductFamily[] => {
    const productFamilyData: ProductFamilyQuery['allKontentItemDataProductFamily'] =
        usePageDataset('pageProductFamilies');

    return (productFamilyData?.edges ?? [])
        .filter((edge) => {
            return edge.node.preferred_language === 'default';
        })
        .map((edge) => {
            return {
                ...edge.node,
            };
        });
};
